import * as z from "zod";
import { bundleInfoSchema } from "./bundle-info";

export const updateBundleParts = {
  name: "updateBundleParts" as const,
  input: z.object({
    parentVariantId: z.string().min(1),
    /**
     * The items the bundle should have after the update; a variant listed
     * n times ends up with n entries.
     */
    partVariantIds: z.array(z.string().min(1)).max(200),
    /**
     * Index of the one copy to remove. Without it, removing a repeated variant
     * drops its last copy, not the one the merchant picked.
     */
    removedPartIndex: z.number().int().nonnegative().optional(),
  }),
  output: bundleInfoSchema,
};
